'use strict'

$(function () {
	var pageNo = 0
	$('.search-btn').click(function () {
		pageNo = 0
		$('.mescroll-upwarp').remove()
		mescrollArr = initMescroll('mescroll')
	})

	var mescrollArr = initMescroll('mescroll')

	function initMescroll(mescrollId) {
		var mescroll = new MeScroll(mescrollId, {
			down: {
				use: false,
			},
			up: {
				auto: true,
				callback: getListData,
				page: {
					size: 20,
				},
				offset: 100,
				isBounce: false,
				noMoreSize: 5,
				empty: {
					tip: '暂无相关数据~',
				},
				clearEmptyId: 'schoolListBox',
				toTop: {
					//	src: 'http://zyadmin.xhd.cn/static/mescroll/mescroll-totop.png',
					offset: 800,
				},
				htmlNodata: '<p class="upwarp-nodata">我是有底线的！</p>',
			},
		})
		return mescroll
	}

	function getListData(page) {
		var totalSize = page.size
		$.ajax({
			type: 'GET',
			url: 'https://nj.xhd.cn/shool/getsShoolList.jspx',
			data: {
				cid: 19985, //栏目id  学校简介
				siteId: 6,
				title: $('#inputBox').val() || '',
				area: ``,
				course: ``,
				country: ``,
				price: ``,
				pageNo: pageNo,
			},
			dataType: 'json',
			success: function success(curPageData) {
				pageNo++
				var data = curPageData.resultList
				var hasNext = true
				if (data.length && data.length < totalSize) {
					hasNext = false
				}
				mescrollArr.endSuccess(data.length, hasNext)
				setListData(data)
			},
			error: function error() {
				mescrollArr.endErr()
			},
		})
	}

	function setListData(data) {
		var school = ''
		data.forEach(i => {
			school +=
				`<div class="school-list-show clearfix">
         <a class="school-pic" href=` +
				'm' +
				i.url +
				` target="_blank">` +
				` <img src="` +
				i.titleImg +
				`">` +
				`</a>
        <div class="school-infor">
        <h3 class="tlt">` +
				i.title +
				`</h3>
         <p class="condition1">招生年级:<span>` +
				i.grade +
				` </span></p>
        <p class="condition1">开设课程:` +
				i.offerCourses +
				`</p>
        <p class="condition1">所在地区: ` +
				i.area +
				`</p>
         <a class="know-more"  href=` +
				'm' +
				i.url +
				` target="_blank">查看详情</a>
        </div>
        </div>`
		})
		$('#schoolListBox').append(school)
	}
})
